import { useQuery } from "@tanstack/react-query";
import { getJson } from "./getJson.js";
import { queryKeys } from "./query-keys.js";

/** Clef's shadow rating of one signal, as `GET /api/ratings/:signalId` sends it. */
export interface SignalRating {
  takeProbability: number | null;
  conviction: number | null;
  modelVersion: string;
  ratedAt: string;
}

/**
 * Its own read rather than a field on the detail response; see
 * `apps/api/src/routes/ratings.ts` for why.
 *
 * A rating is written once and never revised for a release, so it is fresh
 * for as long as the modal can stay open.
 */
export function useSignalRating(signalId: string) {
  return useQuery({
    queryKey: queryKeys.rating(signalId),
    queryFn: () =>
      getJson<{ rating: SignalRating | null }>(`/api/ratings/${encodeURIComponent(signalId)}`),
    staleTime: 10 * 60_000,
  });
}
